import { InputNumber, InputNumberProps } from 'antd'
import styles from './AInputNumberRange.module.less'
import cls from 'classnames'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  classNames?: string
  testId?: string
  placeholder?: {
    start: string
    end: string
  }
  onChange?: (p: [start: NumberValue, end: NumberValue]) => void
}

type IProps = Pick<InputNumberProps, 'controls' | 'max' | 'min' | 'precision' | 'disabled'> & Props

type NumberValue = string | number | null

const COMPONENT_NAME = 'A-Input-Number-Range'
function AInputNumberRange(props: IProps) {
  const { t } = useTranslation()
  const { placeholder, controls = false, max, min, precision = 0, disabled = false } = props
  const [start, setStart] = useState<NumberValue>(null)
  const [end, setEnd] = useState<NumberValue>(null)
  const classNames = cls(styles[COMPONENT_NAME], props.classNames)
  return (
    <div className={classNames} data-testid={props.testId}>
      <InputNumber
        disabled={disabled}
        controls={controls}
        max={max}
        min={min}
        precision={precision}
        placeholder={placeholder?.start || t('dashboard.projectCreatePage.placeholder.lowerLimit')}
        className={styles.inputNumberItem}
        variant='borderless'
        onChange={(value) => {
          setStart(value)
          props.onChange?.([value, end])
        }}
      />
      <span className={styles.separate}>~</span>
      <InputNumber
        disabled={disabled}
        controls={controls}
        max={max}
        min={min}
        precision={precision}
        placeholder={placeholder?.end || t('dashboard.projectCreatePage.placeholder.upperLimit')}
        className={styles.inputNumberItem}
        variant='borderless'
        onChange={(value) => {
          setEnd(value)
          props.onChange?.([start, value])
        }}
      />
    </div>
  )
}

export default AInputNumberRange
